import { CloudOff, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button.tsx";

export function NeedsInteractionScreen() {
  return (
    <main className="min-h-svh flex items-center justify-center bg-muted/30 p-8">
      <div className="w-full max-w-sm rounded-xl border bg-background p-10 text-center">
        <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-amber-100 dark:bg-amber-950">
          <CloudOff
            className="h-7 w-7 text-amber-600 dark:text-amber-400"
            aria-hidden="true"
          />
        </div>

        <p className="mb-2 text-lg font-medium text-foreground">
          Benutzerinformationen konnten nicht geladen werden
        </p>

        <p className="mb-7 text-sm leading-relaxed text-muted-foreground">
          Deine Anmeldung ist gültig, aber dein Profil konnte nicht abgerufen
          werden. Das liegt meist an einer kurzzeitigen Verbindungsstörung.
        </p>

        <Button
          onClick={() => window.location.reload()}
          className="w-full gap-2"
        >
          <RefreshCw className="h-4 w-4" aria-hidden="true" />
          Erneut versuchen
        </Button>
      </div>
    </main>
  );
}
